module.exports = __webpack_public_path__ + "static/media/PUMPTEC.d9376935.png";